import { AxiosInstance } from 'axios';

export type ChatMessage = {
  role: string;
  content: string;
};

type ChatRequest = {
  store_id: number;
  messages: ChatMessage[];
};

export type ChatResponse = {
  content: string;
  history_limit_reached: boolean;
};

export class ChatbotAPI {
  constructor(private instance: AxiosInstance) {}

  async chat(storeId: number, messages: ChatMessage[]): Promise<ChatResponse> {
    const response = await this.instance.post<ChatResponse>('api/chatbot/chat', {
      store_id: storeId,
      messages,
    } satisfies ChatRequest);
    return response.data;
  }
}
